import { render, staticRenderFns } from "./chartBpks.vue?vue&type=template&id=32f72fd3"
import script from "./chartBpks.vue?vue&type=script&lang=js"
export * from "./chartBpks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports